// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Catalog-style list pages: Medications, Labs, Radiology, Physician Referrals,
 * Referring Providers, CPT, Organizations, Locations, ICD-10-CM, SmartPhrases,
 * Users, Access Control, Allergen Master, and Px Master.
 * Namespaced so other pages stay unchanged. */

.emr-catalog,
.emr-catalog *,
.emr-catalog *::before,
.emr-catalog *::after {
  border-radius: 0 !important;
}

.emr-mz-dashboard .emr-mz-main:has(.emr-catalog) {
  padding: 10px 12px 12px !important;
  max-width: none;
  overflow-x: hidden;
}

.emr-catalog {
  --emr-catalog-primary: #1976d2;
  --emr-catalog-primary-dark: #0d47a1;
  --emr-catalog-text: #212121;
  --emr-catalog-muted: #616161;
  --emr-catalog-border: #e0e0e0;
  --emr-catalog-surface: #ffffff;
  max-width: none;
  margin: 0;
  min-width: 0;
  width: 100%;
  box-sizing: border-box;
  color: var(--emr-catalog-text);
  overflow-x: hidden;
}

.emr-catalog__pagehead {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 8px;
  min-width: 0;
}

.emr-mz-dashboard .emr-catalog__title,
.emr-catalog__title {
  margin: 0;
  font-size: var(--emr-type-page-title) !important;
  font-weight: 600;
  line-height: 1.25;
  color: var(--emr-catalog-text);
}

.emr-catalog__workspace {
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  gap: 8px;
  align-items: start;
  min-width: 0;
}

.emr-catalog__side {
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  gap: 8px;
  align-content: start;
  min-width: 0;
}

.emr-catalog__catalog {
  min-width: 0;
}

.emr-catalog .card.emr-catalog__section,
.emr-catalog__section {
  margin: 0;
  width: 100%;
  max-width: 100%;
  min-width: 0;
  overflow: hidden;
  background: var(--emr-catalog-surface);
  border: 1px solid var(--emr-catalog-border);
  border-right: 3px solid var(--emr-catalog-primary);
  box-shadow: none;
  padding: 8px 12px 10px;
  box-sizing: border-box;
}

.emr-catalog__section-title {
  margin: 0 0 6px;
  font-size: var(--emr-type-metadata) !important;
  font-weight: 600;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--emr-catalog-muted);
}

.emr-catalog__copy {
  margin: 0;
  font-size: var(--emr-type-body);
  font-weight: 400;
  line-height: 1.4;
  color: var(--emr-catalog-text);
}

.emr-catalog__section--notice {
  background: #fff8e1;
  border-color: #ffe082;
  border-right-width: 3px;
  border-right-color: var(--emr-catalog-primary);
}

.emr-catalog__section--notice .emr-catalog__section-title {
  color: #f57f17;
}

.emr-catalog__section--notice .emr-catalog__copy {
  color: #5d4037;
}

.emr-catalog__status-msg,
.emr-catalog__empty {
  padding: 28px 16px;
  text-align: center;
  font-size: var(--emr-type-body);
  color: var(--emr-catalog-muted);
}

.emr-catalog__empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
}

.emr-catalog__empty-icon {
  width: 32px;
  height: 32px;
  color: #bdbdbd;
}

.emr-catalog__error {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  padding: 28px 16px;
  text-align: center;
}

.emr-catalog__error-icon {
  width: 32px;
  height: 32px;
  color: #ef9a9a;
}

.emr-catalog__error-copy {
  margin: 0;
  max-width: 28rem;
  font-size: var(--emr-type-body);
  color: var(--emr-catalog-muted);
}

.emr-mz-dashboard .btn.emr-catalog__retry,
.emr-catalog__retry {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 36px;
  padding: 0 14px;
  margin: 0;
  background: #fff !important;
  color: var(--emr-catalog-primary) !important;
  border: 1px solid var(--emr-catalog-primary);
  box-shadow: none;
}

.emr-mz-dashboard .btn.emr-catalog__retry:hover,
.emr-catalog__retry:hover {
  background: #e3f2fd !important;
}

.emr-catalog__table-wrap {
  display: block;
  width: 100%;
  max-width: 100%;
  min-width: 0;
  overflow-x: auto;
  overflow-y: hidden;
  -webkit-overflow-scrolling: touch;
}

/* (0,2,1) so the 16px band beats Materialize's
   \`.emr-mz-dashboard table { font-size: var(--emr-type-table) }\` (0,1,1). */
.emr-mz-dashboard table.emr-catalog__table,
.emr-catalog__table {
  display: table;
  width: 100%;
  min-width: 720px;
  border-collapse: collapse;
  position: static;
  font-family: var(--emr-font-sans);
  font-size: 16px;
}

.emr-mz-dashboard table.emr-catalog__table thead {
  display: table-header-group;
  position: static;
  float: none;
  overflow: visible;
  width: auto;
}

.emr-mz-dashboard table.emr-catalog__table tbody {
  display: table-row-group;
}

.emr-mz-dashboard table.emr-catalog__table tr {
  display: table-row;
}

/* Row geometry lives here on purpose. This selector is (0,2,2) and therefore
 * outranks the \`.emr-mz-dashboard .emr-catalog__table td\` rule below at (0,2,1),
 * so vertical padding and line-height set further down would lose. It also
 * clears Materialize's \`.emr-mz-dashboard td, th { padding: 15px 5px }\` (0,1,1)
 * without !important.
 *
 * Same accepted clinical density as the patient-chart and worklist tables:
 * Arial, 16px text on a 16px line, 20px data rows, 2px vertical cell padding.
 * The 12px horizontal gutter is kept from the existing design — these tables
 * declare a min-width and scroll inside .emr-catalog__table-wrap, so narrowing
 * the gutter would only crowd the columns.
 *
 * font-family stops at the cell: \`.emr-mz-dashboard.emr-mz-dashboard .font-fhir\`
 * is (0,3,0) and still wins, so code columns (ICD-10-CM, CPT, Px Master local
 * codes, NPIs) stay monospace at the 16px standard.
 */
.emr-mz-dashboard table.emr-catalog__table th,
.emr-mz-dashboard table.emr-catalog__table td {
  display: table-cell;
  box-sizing: border-box;
  height: 20px;
  max-height: 20px;
  padding-top: 2px;
  padding-bottom: 2px;
  font-family: var(--emr-font-sans);
  font-size: 16px;
  line-height: 16px;
  vertical-align: middle;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  /* On a single line the long free-text columns (CPT and ICD-10-CM official
     descriptions, placeholder meanings and sources, provider organizations) no
     longer wrap, so \`table-layout: auto\` would size them to their full string
     and push later columns out of the scroll viewport. Capping the column is
     what makes the ellipsis above reachable. */
  max-width: 360px;
}

.emr-mz-dashboard .emr-catalog__table th {
  font-size: 16px;
  font-weight: 600;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--emr-catalog-muted);
  padding: 2px 12px;
  line-height: 16px;
  border-bottom: 1px solid var(--emr-catalog-border);
  background: #fafbfc;
  white-space: nowrap;
}

.emr-mz-dashboard .emr-catalog__table td {
  font-size: 16px;
  font-weight: 400;
  padding: 2px 12px;
  line-height: 16px;
  color: var(--emr-catalog-text);
  border-bottom: 1px solid #f0f0f0;
  vertical-align: middle;
}

.emr-catalog__name {
  font-weight: 600;
  color: var(--emr-catalog-primary-dark);
}

.emr-catalog__muted {
  font-size: var(--emr-type-helper);
  color: var(--emr-catalog-muted);
}

/* A 20px row leaves a 16px content box once 2px + 2px cell padding is taken,
   so every in-row chip, token and action button is sized to exactly 16px. */
.emr-catalog__status {
  display: inline-flex;
  align-items: center;
  height: 16px;
  padding: 0 8px;
  font-size: 16px;
  line-height: 16px;
  font-weight: 600;
  letter-spacing: 0.02em;
  white-space: nowrap;
}

.emr-catalog__status--active {
  background: #e3f2fd;
  color: #1565c0;
}

.emr-catalog__status--transform {
  background: #fff8e1;
  color: #f57f17;
}

.emr-catalog__status--inactive {
  background: #eceff1;
  color: #546e7a;
}

.emr-catalog__token--placeholder {
  font-family: var(--emr-font-mono);
  letter-spacing: 0;
  font-weight: 600;
}

/* Placeholder Vocabulary renders its token as <code>, where Materialize's
   \`.emr-mz-dashboard code { font-size: 1em }\` (0,1,1) outranks this rule and the
   token inherits the cell instead. Both paths now land on 16px. */
.emr-catalog__token {
  display: inline-flex;
  align-items: center;
  height: 16px;
  padding: 0 7px;
  background: #eceff1;
  color: #37474f;
  font-size: 16px;
  line-height: 16px;
  font-weight: 600;
  letter-spacing: 0.02em;
  white-space: nowrap;
}

/* Referring Providers is the one column that used to wrap an address over
   several lines. On a 20px row it becomes a single truncated line, the same
   treatment the accepted Appointments notes column already uses; the full
   address stays available in the provider detail. Qualified to (0,3,2) so this
   column keeps its own tighter bound instead of the table-wide 360px cap. */
.emr-mz-dashboard table.emr-catalog__table td.emr-catalog__address,
.emr-catalog__address {
  max-width: 260px;
}

.emr-mz-dashboard table.emr-catalog__table--wide,
.emr-catalog__table--wide {
  min-width: 1080px;
}

@media only screen and (min-width: 1024px) {
  .emr-catalog__side {
    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  }
}

@media only screen and (min-width: 1440px) {
  .emr-catalog__workspace {
    grid-template-columns: minmax(280px, 340px) minmax(0, 1fr);
  }

  .emr-catalog__side {
    grid-template-columns: minmax(0, 1fr);
  }

  .emr-catalog--full-table .emr-catalog__workspace {
    grid-template-columns: minmax(0, 1fr);
  }

  .emr-catalog--full-table .emr-catalog__side {
    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  }
}

@media only screen and (max-width: 600px) {
  .emr-mz-dashboard .emr-catalog__title,
  .emr-catalog__title {
    font-size: var(--emr-type-page-title-compact) !important;
  }

  .emr-mz-dashboard .emr-catalog__table th,
  .emr-mz-dashboard .emr-catalog__table td {
    padding: 2px 10px;
  }

  .emr-mz-dashboard table.emr-catalog__table,
  .emr-catalog__table {
    min-width: 560px;
  }

  .emr-mz-dashboard table.emr-catalog__table--wide,
  .emr-catalog__table--wide {
    min-width: 960px;
  }

  .emr-catalog__pagehead {
    flex-direction: column;
    align-items: stretch;
    gap: 8px;
  }

  .emr-mz-dashboard .btn.emr-catalog__btn,
  .emr-catalog__btn {
    width: 100%;
    justify-content: center;
  }

  .emr-catalog__filters {
    grid-template-columns: minmax(0, 1fr);
  }
}

.emr-catalog__subtitle {
  margin: 2px 0 0;
  font-size: var(--emr-type-helper);
  font-weight: 400;
  color: var(--emr-catalog-muted);
}

.emr-mz-dashboard .btn.emr-catalog__btn,
.emr-catalog__btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  height: 36px;
  padding: 0 14px;
  margin: 0;
  flex-shrink: 0;
  background: var(--emr-catalog-primary) !important;
  color: #fff !important;
  border: 0;
  box-shadow: none;
  text-transform: none;
  font-size: var(--emr-type-button);
  font-weight: 600;
  line-height: 36px;
}

.emr-mz-dashboard .btn.emr-catalog__btn:hover,
.emr-catalog__btn:hover {
  background: var(--emr-catalog-primary-dark) !important;
}

.emr-catalog__btn-icon {
  width: 16px;
  height: 16px;
}

.emr-mz-dashboard .btn.emr-catalog__btn--ghost,
.emr-catalog__btn--ghost {
  background: #fff !important;
  color: var(--emr-catalog-primary) !important;
  border: 1px solid var(--emr-catalog-primary);
}

.emr-mz-dashboard .btn.emr-catalog__btn--ghost:hover,
.emr-catalog__btn--ghost:hover {
  background: #e3f2fd !important;
}

.emr-mz-dashboard .btn.emr-catalog__btn--danger,
.emr-catalog__btn--danger {
  background: #d32f2f !important;
}

.emr-catalog__filters {
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  gap: 8px;
  align-items: end;
  min-width: 0;
}

.emr-catalog__search {
  position: relative;
  min-width: 0;
  width: 100%;
}

.emr-catalog__search-icon {
  position: absolute;
  left: 10px;
  top: 50%;
  width: 16px;
  height: 16px;
  margin-top: -8px;
  color: #9e9e9e;
  pointer-events: none;
}

.emr-mz-dashboard .emr-catalog__input,
.emr-catalog__input,
.emr-mz-dashboard .emr-catalog__select,
.emr-catalog__select,
.emr-mz-dashboard .emr-catalog__filter-trigger,
.emr-catalog__filter-trigger {
  height: 36px !important;
  min-height: 36px !important;
  width: 100% !important;
  max-width: 100%;
  min-width: 0;
  box-sizing: border-box !important;
  margin: 0;
  border: 1px solid var(--emr-catalog-border) !important;
  background: var(--emr-catalog-surface) !important;
  box-shadow: none !important;
  font-size: var(--emr-type-body) !important;
  font-weight: 400 !important;
  color: var(--emr-catalog-text) !important;
}

.emr-mz-dashboard .emr-catalog__input,
.emr-catalog__input {
  padding: 0 10px 0 32px !important;
}

.emr-mz-dashboard .emr-catalog__select,
.emr-catalog__select {
  padding: 0 8px !important;
  display: block;
}

.emr-catalog-select {
  border-radius: 0 !important;
  border: 1px solid var(--emr-catalog-border) !important;
  background: #fff !important;
  box-shadow: none !important;
}

.emr-catalog__field {
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
}

.emr-catalog__field > span,
.emr-catalog__field-label {
  font-size: var(--emr-type-label);
  font-weight: 600;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: var(--emr-catalog-muted);
}

.emr-catalog__switch {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  height: 36px;
  padding: 0 10px;
  border: 1px solid var(--emr-catalog-border);
  background: var(--emr-catalog-surface);
  font-size: var(--emr-type-body);
  color: var(--emr-catalog-text);
}

/* The DEMO flag keeps --emr-type-micro: emr-typography.css reserves sub-12px
   for exactly this kind of incidental chrome ("rulers, demo-data flags"). Only
   its box shrinks, so it fits the 16px content box.
   It sits beside the name text, and a 16px box aligned \`middle\` in a 16px line
   box overhangs it by 0.77px, which grew the whole row. \`top\` fills the line box
   exactly, so the chip still reads centred and the row stays at 20px. */
.emr-catalog__demo {
  display: inline-flex;
  align-items: center;
  height: 16px;
  margin-left: 8px;
  padding: 0 6px;
  background: #fff8e1;
  color: #f9a825;
  font-size: var(--emr-type-micro);
  font-weight: 700;
  letter-spacing: 0.06em;
  vertical-align: top;
}

.emr-catalog__status--suspended {
  background: #fff8e1;
  color: #f9a825;
}

.emr-catalog__actions-col {
  text-align: right;
  white-space: nowrap;
}

.emr-catalog__row-actions {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 2px;
  height: 16px;
}

/* Role tokens on Users used to wrap onto a second line. They now stay on one
   line inside the row and the cell truncates, matching every other column. */
.emr-catalog__chips {
  display: flex;
  flex-wrap: nowrap;
  justify-content: flex-start;
  align-items: center;
  gap: 4px;
  height: 16px;
  overflow: hidden;
}

.emr-mz-dashboard .emr-catalog-icon-btn {
  width: 16px !important;
  height: 16px !important;
  min-width: 16px !important;
  min-height: 16px !important;
  padding: 0 !important;
  line-height: 1 !important;
  color: var(--emr-catalog-primary);
}

.emr-mz-dashboard .emr-catalog-icon-btn--danger {
  color: #d32f2f;
}

.emr-mz-dashboard a.emr-catalog__link,
.emr-catalog__link {
  color: var(--emr-catalog-primary-dark);
  font-weight: 600;
  text-decoration: none;
}

.emr-mz-dashboard a.emr-catalog__link:hover,
.emr-catalog__link:hover {
  text-decoration: underline;
}

.emr-catalog__pager {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin-top: 8px;
  padding-top: 8px;
  border-top: 1px solid var(--emr-catalog-border);
  font-size: var(--emr-type-label);
  color: var(--emr-catalog-muted);
}

.emr-catalog__cap {
  margin: 8px 0 0;
  padding: 6px 8px;
  background: #fff8e1;
  color: #5d4037;
  font-size: var(--emr-type-helper);
  text-align: center;
}

.emr-catalog__meta {
  margin: 6px 0 0;
  font-size: var(--emr-type-helper);
  color: var(--emr-catalog-muted);
}

/* Prefixed and element-qualified so the 16px line beats Materialize's
   \`.emr-mz-dashboard button { line-height: 1.15 }\` (0,1,1) without !important. */
.emr-mz-dashboard button.emr-catalog__text-btn,
.emr-catalog__text-btn {
  display: inline-flex;
  align-items: center;
  height: 16px;
  padding: 0 6px;
  border: 0;
  background: transparent;
  color: var(--emr-catalog-primary);
  font-size: 16px;
  line-height: 16px;
  font-weight: 600;
  cursor: pointer;
}

.emr-catalog__text-btn:hover {
  text-decoration: underline;
}

@media only screen and (min-width: 720px) {
  .emr-catalog__filters {
    grid-template-columns: minmax(0, 1.4fr) repeat(auto-fit, minmax(140px, 180px));
  }

  .emr-catalog__filters--search-only {
    grid-template-columns: minmax(0, 1fr);
    max-width: 420px;
  }

  .emr-catalog__filters--search-row {
    grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));
  }

  .emr-catalog__filters--search-row .emr-catalog__search {
    grid-column: 1 / -1;
    min-width: 0;
  }

  .emr-catalog__filters--vocab {
    grid-template-columns: minmax(22rem, max-content) max-content;
  }

  .emr-catalog__select--wide {
    width: auto !important;
    min-width: 22rem !important;
    max-width: 32rem;
  }
}

.emr-catalog--access {
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  gap: 8px;
}

.emr-catalog--access .emr-catalog__pagehead {
  margin-bottom: 0;
}

.emr-catalog--access .emr-catalog__workspace {
  gap: 8px;
}

.emr-catalog--access .ac-tabs {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 8px;
  margin: 0;
}

.emr-catalog--access .ac-tab {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
  border: 1px solid var(--emr-catalog-border);
  background: #fff;
  padding: 8px 10px;
  text-align: left;
  color: var(--emr-catalog-text);
}

.emr-catalog--access .ac-tab.is-active {
  border-color: var(--emr-catalog-primary);
  box-shadow: inset 0 -3px 0 var(--emr-catalog-primary);
  color: var(--emr-catalog-primary-dark);
}

.emr-catalog--access .ac-tab.is-disabled {
  opacity: 0.55;
  cursor: not-allowed;
}

.emr-catalog--access .ac-tab-label {
  display: block;
  font-size: var(--emr-type-body);
  font-weight: 600;
}

.emr-catalog--access .ac-tab-sub {
  display: block;
  font-size: var(--emr-type-metadata);
  color: var(--emr-catalog-muted);
}

.emr-catalog--access .ac-toolbar,
.emr-catalog--access .ac-toolbar--user {
  display: grid;
  grid-template-columns: minmax(160px, 240px) minmax(0, 1fr);
  gap: 8px;
  margin: 0;
  align-items: start;
}

.emr-catalog--access .ac-field {
  display: flex;
  flex-direction: column;
  gap: 4px;
  font-size: var(--emr-type-label);
  font-weight: 600;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: var(--emr-catalog-muted);
}

.emr-mz-dashboard .emr-catalog--access .ac-field select,
.emr-catalog--access .ac-field select {
  display: block !important;
  visibility: visible !important;
  opacity: 1 !important;
  width: 100%;
  max-width: 100%;
  height: 36px !important;
  min-height: 36px !important;
  margin: 0;
  border: 1px solid var(--emr-catalog-border);
  background: #fff;
  padding: 0 8px;
  font-size: var(--emr-type-body);
  font-weight: 400;
  text-transform: none;
  letter-spacing: 0;
  color: var(--emr-catalog-text);
  appearance: auto;
  -webkit-appearance: menulist;
}

.emr-catalog--access .ac-info {
  display: flex;
  gap: 8px;
  align-items: flex-start;
  margin: 0;
  background: #e3f2fd;
  border: 1px solid #bbdefb;
  color: var(--emr-catalog-primary-dark);
  padding: 8px 10px;
  font-size: var(--emr-type-body);
}

.emr-catalog--access .ac-employee {
  display: grid;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  gap: 8px;
  margin: 0;
  border: 0;
  padding: 0;
  background: transparent;
}

.emr-catalog--access .ac-employee span {
  display: block;
  font-size: var(--emr-type-metadata);
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: var(--emr-catalog-muted);
  font-weight: 600;
}

.emr-catalog--access .ac-employee strong {
  display: block;
  margin-top: 2px;
  font-size: var(--emr-type-body);
  color: var(--emr-catalog-text);
  font-weight: 600;
}

.emr-catalog--access .ac-matrix,
.emr-catalog--access .ac-hierarchy {
  border-radius: 0 !important;
  overflow-x: auto;
  max-width: 100%;
}

.emr-catalog--access .ac-matrix-table th,
.emr-catalog--access .ac-matrix-table td {
  padding: 6px 8px;
}

.emr-catalog--access .ac-footer,
.emr-catalog--access .ac-footer--user {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin: 0;
}

.emr-catalog--access .ac-save--default,
.emr-catalog--access .ac-save--user {
  background: var(--emr-catalog-primary) !important;
  color: #fff !important;
}

.emr-catalog--access .ac-save--default:hover,
.emr-catalog--access .ac-save--user:hover {
  background: var(--emr-catalog-primary-dark) !important;
}

.emr-catalog--access .ac-loading,
.emr-catalog--access .ac-footnote {
  margin: 0;
  font-size: var(--emr-type-helper);
  color: var(--emr-catalog-muted);
}

@media only screen and (max-width: 900px) {
  .emr-catalog--access .ac-tabs,
  .emr-catalog--access .ac-toolbar,
  .emr-catalog--access .ac-toolbar--user,
  .emr-catalog--access .ac-employee,
  .emr-catalog--access .ac-footer,
  .emr-catalog--access .ac-footer--user {
    grid-template-columns: minmax(0, 1fr);
    display: flex;
    flex-direction: column;
  }
}

.emr-catalog--access .ac-workspace-tabs {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;
  margin: 0;
}

.emr-catalog--access .ac-workspace-tab {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  min-width: 0;
  border: 1px solid var(--emr-catalog-border);
  background: #fff;
  padding: 10px 12px;
  text-align: left;
  color: var(--emr-catalog-text);
}

.emr-catalog--access .ac-workspace-tab.is-active {
  border-color: var(--emr-catalog-primary);
  background: #e3f2fd;
  box-shadow: inset 0 -3px 0 var(--emr-catalog-primary);
  color: var(--emr-catalog-primary-dark);
}

.emr-catalog--access .ac-role-help {
  flex-shrink: 0;
}

.emr-catalog--access .ac-perm {
  display: grid;
  gap: 8px;
  min-width: 0;
}

.emr-catalog--access .ac-perm-title {
  margin: 0;
  font-size: var(--emr-type-section-title) !important;
  font-weight: 600;
  color: var(--emr-catalog-text);
  text-transform: none;
  letter-spacing: 0;
}

.emr-catalog--access .ac-perm-subtitle,
.emr-catalog--access .ac-perm-preferred-note {
  margin: 2px 0 0;
  font-size: var(--emr-type-helper);
  color: var(--emr-catalog-muted);
  font-weight: 400;
  text-transform: none;
  letter-spacing: 0;
}

.emr-catalog--access .ac-perm-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-top: 8px;
  flex-wrap: wrap;
}

.emr-catalog--access .ac-perm-preferred {
  height: 32px;
  padding: 0 10px;
}

.emr-catalog--access .ac-perm-guide {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: var(--emr-type-body);
  font-weight: 600;
  color: var(--emr-catalog-primary-dark);
  text-decoration: underline;
  text-underline-offset: 2px;
}

.emr-catalog--access .ac-perm-guide svg {
  width: 14px;
  height: 14px;
}

.emr-catalog--access .ac-perm-group-title {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 0 0 6px;
  font-size: var(--emr-type-card-title) !important;
  font-weight: var(--emr-weight-title);
  letter-spacing: 0.02em;
  text-transform: none;
  color: var(--emr-catalog-text);
}

.emr-catalog--access .ac-perm-num {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 18px;
  height: 18px;
  padding: 0 5px;
  background: #e3f2fd;
  color: var(--emr-catalog-primary-dark);
  font-size: var(--emr-type-micro);
  font-weight: 700;
}

.emr-catalog--access .ac-perm-table-wrap {
  overflow-x: auto;
  max-width: 100%;
}

.emr-catalog--access .ac-perm-table {
  width: 100%;
  border-collapse: collapse;
  font-size: var(--emr-type-table-dense);
}

.emr-catalog--access .ac-perm-table th,
.emr-catalog--access .ac-perm-table td {
  border-bottom: 1px solid var(--emr-catalog-border);
  padding: 4px 8px;
  text-align: left;
  vertical-align: middle;
}

.emr-catalog--access .ac-perm-table thead th {
  font-size: var(--emr-type-table-head);
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: var(--emr-catalog-muted);
  background: #fafafa;
  white-space: nowrap;
}

.emr-catalog--access .ac-perm-table thead th:not(:first-child),
.emr-catalog--access .ac-perm-table td {
  text-align: center;
  width: 110px;
}

.emr-catalog--access .ac-perm-label {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-weight: 500;
  color: var(--emr-catalog-text);
}

.emr-catalog--access .ac-perm-info {
  position: relative;
  display: inline-flex;
}

.emr-catalog--access .ac-perm-info-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
  padding: 0;
  border: 0;
  background: transparent;
  color: var(--emr-catalog-muted);
  cursor: pointer;
}

.emr-catalog--access .ac-perm-info-btn svg {
  width: 13px;
  height: 13px;
}

.emr-catalog--access .ac-perm-tip {
  display: none;
  position: absolute;
  left: 0;
  top: 20px;
  z-index: 8;
  min-width: 180px;
  max-width: 260px;
  padding: 6px 8px;
  background: #0d47a1;
  color: #fff;
  font-size: var(--emr-type-helper);
  font-weight: 400;
  line-height: 1.35;
  box-shadow: 0 2px 8px rgba(13, 71, 161, 0.25);
}

.emr-catalog--access .ac-perm-info:hover .ac-perm-tip,
.emr-catalog--access .ac-perm-info:focus-within .ac-perm-tip,
.emr-catalog--access .ac-perm-info.is-open .ac-perm-tip {
  display: block;
}

.emr-catalog--access .ac-perm-check-wrap {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin: 0;
}

.emr-mz-dashboard .emr-catalog--access input.ac-perm-check[type="checkbox"],
.emr-catalog--access input.ac-perm-check[type="checkbox"] {
  position: static !important;
  left: auto !important;
  opacity: 1 !important;
  pointer-events: auto !important;
  visibility: visible !important;
  appearance: auto !important;
  -webkit-appearance: checkbox !important;
  width: 16px !important;
  height: 16px !important;
  margin: 0 !important;
  z-index: auto !important;
  accent-color: #1976d2;
}

.emr-catalog--access .ac-perm-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  flex-wrap: wrap;
  margin-top: 0;
}

.emr-catalog--access .ac-perm-actions {
  display: flex;
  align-items: center;
  gap: 8px;
}

.emr-catalog--access .ac-role-copy {
  display: grid;
  gap: 8px;
  text-align: left;
  color: var(--emr-catalog-text);
}

.emr-catalog--access .ac-role-copy p {
  margin: 0;
  font-size: var(--emr-type-body);
  line-height: 1.45;
}

@media only screen and (max-width: 1100px) {
  .emr-catalog--access .ac-workspace-tabs {
    grid-template-columns: minmax(0, 1fr);
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/emr-catalog.css"],"names":[],"mappings":"AAAA;;;8CAG8C;;AAE9C;;;;EAIE,2BAA2B;AAC7B;;AAEA;EACE,kCAAkC;EAClC,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,8BAA8B;EAC9B,mCAAmC;EACnC,2BAA2B;EAC3B,4BAA4B;EAC5B,6BAA6B;EAC7B,8BAA8B;EAC9B,eAAe;EACf,SAAS;EACT,YAAY;EACZ,WAAW;EACX,sBAAsB;EACtB,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,YAAY;AACd;;AAEA;;EAEE,SAAS;EACT,gDAAgD;EAChD,gBAAgB;EAChB,iBAAiB;EACjB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,QAAQ;EACR,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,QAAQ;EACR,oBAAoB;EACpB,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;;EAEE,SAAS;EACT,WAAW;EACX,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,sCAAsC;EACtC,2CAA2C;EAC3C,kDAAkD;EAClD,gBAAgB;EAChB,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,8CAA8C;EAC9C,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,+BAA+B;AACjC;;AAEA;EACE,SAAS;EACT,+BAA+B;EAC/B,gBAAgB;EAChB,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,uBAAuB;EACvB,8CAA8C;AAChD;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,kBAAkB;EAClB,kBAAkB;EAClB,+BAA+B;EAC/B,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,+BAA+B;EAC/B,+BAA+B;AACjC;;AAEA;;EAEE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,SAAS;EACT,2BAA2B;EAC3B,4CAA4C;EAC5C,4CAA4C;EAC5C,gBAAgB;AAClB;;AAEA;;EAEE,8BAA8B;AAChC;;AAEA;EACE,cAAc;EACd,WAAW;EACX,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;4EAC4E;AAC5E;;EAEE,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,gBAAgB;EAChB,iCAAiC;EACjC,eAAe;AACjB;;AAEA;EACE,2BAA2B;EAC3B,gBAAgB;EAChB,WAAW;EACX,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;;;;;;;;;;;;;;EAeE;AACF;;EAEE,mBAAmB;EACnB,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,iCAAiC;EACjC,eAAe;EACf,iBAAiB;EACjB,sBAAsB;EACtB,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB;;;;+CAI6C;EAC7C,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,+BAA+B;EAC/B,iBAAiB;EACjB,iBAAiB;EACjB,kDAAkD;EAClD,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,8BAA8B;EAC9B,gCAAgC;EAChC,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,sCAAsC;AACxC;;AAEA;EACE,iCAAiC;EACjC,+BAA+B;AACjC;;AAEA;4EAC4E;AAC5E;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,iCAAiC;EACjC,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;;kEAEkE;AAClE;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;;;;4EAI4E;AAC5E;;EAEE,gBAAgB;AAClB;;AAEA;;EAEE,iBAAiB;AACnB;;AAEA;EACE;IACE,oDAAoD;EACtD;AACF;;AAEA;EACE;IACE,0DAA0D;EAC5D;;EAEA;IACE,qCAAqC;EACvC;;EAEA;IACE,qCAAqC;EACvC;;EAEA;IACE,oDAAoD;EACtD;AACF;;AAEA;EACE;;IAEE,wDAAwD;EAC1D;;EAEA;;IAEE,iBAAiB;EACnB;;EAEA;;IAEE,gBAAgB;EAClB;;EAEA;;IAEE,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;IACpB,QAAQ;EACV;;EAEA;;IAEE,WAAW;IACX,uBAAuB;EACzB;;EAEA;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE,eAAe;EACf,iCAAiC;EACjC,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;;EAEE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,SAAS;EACT,cAAc;EACd,iDAAiD;EACjD,sBAAsB;EACtB,SAAS;EACT,gBAAgB;EAChB,oBAAoB;EACpB,iCAAiC;EACjC,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;;EAEE,sDAAsD;AACxD;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;;EAEE,2BAA2B;EAC3B,4CAA4C;EAC5C,4CAA4C;AAC9C;;AAEA;;EAEE,8BAA8B;AAChC;;AAEA;;EAEE,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,QAAQ;EACR,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,cAAc;EACd,oBAAoB;AACtB;;AAEA;;;;;;EAME,uBAAuB;EACvB,2BAA2B;EAC3B,sBAAsB;EACtB,eAAe;EACf,YAAY;EACZ,iCAAiC;EACjC,SAAS;EACT,sDAAsD;EACtD,iDAAiD;EACjD,2BAA2B;EAC3B,0CAA0C;EAC1C,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;;EAEE,iCAAiC;AACnC;;AAEA;;EAEE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,2BAA2B;EAC3B,sDAAsD;EACtD,2BAA2B;EAC3B,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;;AAEA;;EAEE,gCAAgC;EAChC,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,+BAA+B;AACjC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,2CAA2C;EAC3C,sCAAsC;EACtC,+BAA+B;EAC/B,8BAA8B;AAChC;;AAEA;;;;;wEAKwE;AACxE;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,cAAc;EACd,gCAAgC;EAChC,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,QAAQ;EACR,YAAY;AACd;;AAEA;6EAC6E;AAC7E;EACE,aAAa;EACb,iBAAiB;EACjB,2BAA2B;EAC3B,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,0BAA0B;EAC1B,2BAA2B;EAC3B,qBAAqB;EACrB,yBAAyB;EACzB,iCAAiC;AACnC;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,sCAAsC;EACtC,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;;EAEE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,+CAA+C;EAC/C,gCAAgC;EAChC,+BAA+B;AACjC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,iCAAiC;EACjC,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,iCAAiC;EACjC,+BAA+B;AACjC;;AAEA;iFACiF;AACjF;;EAEE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,cAAc;EACd,SAAS;EACT,uBAAuB;EACvB,iCAAiC;EACjC,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE;IACE,8EAA8E;EAChF;;EAEA;IACE,qCAAqC;IACrC,gBAAgB;EAClB;;EAEA;IACE,2DAA2D;EAC7D;;EAEA;IACE,mBAAmB;IACnB,YAAY;EACd;;EAEA;IACE,6DAA6D;EAC/D;;EAEA;IACE,sBAAsB;IACtB,2BAA2B;IAC3B,gBAAgB;EAClB;AACF;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,QAAQ;AACV;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,2CAA2C;EAC3C,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE,wCAAwC;EACxC,qDAAqD;EACrD,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,mCAAmC;EACnC,+BAA+B;AACjC;;AAEA;;EAEE,aAAa;EACb,0DAA0D;EAC1D,QAAQ;EACR,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gCAAgC;EAChC,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,+BAA+B;AACjC;;AAEA;;EAEE,yBAAyB;EACzB,8BAA8B;EAC9B,qBAAqB;EACrB,WAAW;EACX,eAAe;EACf,uBAAuB;EACvB,2BAA2B;EAC3B,SAAS;EACT,2CAA2C;EAC3C,gBAAgB;EAChB,cAAc;EACd,+BAA+B;EAC/B,gBAAgB;EAChB,oBAAoB;EACpB,iBAAiB;EACjB,8BAA8B;EAC9B,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,uBAAuB;EACvB,SAAS;EACT,mBAAmB;EACnB,yBAAyB;EACzB,sCAAsC;EACtC,iBAAiB;EACjB,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,QAAQ;EACR,SAAS;EACT,SAAS;EACT,UAAU;EACV,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,mCAAmC;EACnC,yBAAyB;EACzB,sBAAsB;EACtB,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,+BAA+B;EAC/B,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;;EAEE,2BAA2B;EAC3B,gBAAgB;EAChB,eAAe;AACjB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;;EAEE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,SAAS;AACX;;AAEA;;EAEE,iDAAiD;EACjD,sBAAsB;AACxB;;AAEA;;EAEE,sDAAsD;AACxD;;AAEA;;EAEE,SAAS;EACT,iCAAiC;EACjC,+BAA+B;AACjC;;AAEA;EACE;;;;;;IAME,qCAAqC;IACrC,aAAa;IACb,sBAAsB;EACxB;AACF;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,YAAY;EACZ,2CAA2C;EAC3C,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE,wCAAwC;EACxC,mBAAmB;EACnB,qDAAqD;EACrD,sCAAsC;AACxC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,SAAS;EACT,mDAAmD;EACnD,gBAAgB;EAChB,8BAA8B;EAC9B,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;;EAEE,eAAe;EACf,iCAAiC;EACjC,+BAA+B;EAC/B,gBAAgB;EAChB,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,+BAA+B;EAC/B,gBAAgB;EAChB,sCAAsC;EACtC,0BAA0B;EAC1B,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gDAAgD;EAChD,oCAAoC;EACpC,sBAAsB;EACtB,oBAAoB;EACpB,8BAA8B;AAChC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,sCAAsC;EACtC,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,sCAAsC;AACxC;;AAEA;;EAEE,kDAAkD;EAClD,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,qCAAqC;EACrC,sBAAsB;EACtB,yBAAyB;EACzB,+BAA+B;EAC/B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;;EAEE,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,SAAS;EACT,uBAAuB;EACvB,+BAA+B;EAC/B,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,OAAO;EACP,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;EACX,iCAAiC;EACjC,gBAAgB;EAChB,iBAAiB;EACjB,6CAA6C;AAC/C;;AAEA;;;EAGE,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;AACX;;AAEA;;EAEE,2BAA2B;EAC3B,qBAAqB;EACrB,qBAAqB;EACrB,+BAA+B;EAC/B,8BAA8B;EAC9B,2BAA2B;EAC3B,uCAAuC;EACvC,sBAAsB;EACtB,uBAAuB;EACvB,oBAAoB;EACpB,wBAAwB;EACxB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,eAAe;EACf,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE,SAAS;EACT,+BAA+B;EAC/B,iBAAiB;AACnB;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF","sourcesContent":["/* Catalog-style list pages: Medications, Labs, Radiology, Physician Referrals,\n * Referring Providers, CPT, Organizations, Locations, ICD-10-CM, SmartPhrases,\n * Users, Access Control, Allergen Master, and Px Master.\n * Namespaced so other pages stay unchanged. */\n\n.emr-catalog,\n.emr-catalog *,\n.emr-catalog *::before,\n.emr-catalog *::after {\n  border-radius: 0 !important;\n}\n\n.emr-mz-dashboard .emr-mz-main:has(.emr-catalog) {\n  padding: 10px 12px 12px !important;\n  max-width: none;\n  overflow-x: hidden;\n}\n\n.emr-catalog {\n  --emr-catalog-primary: #1976d2;\n  --emr-catalog-primary-dark: #0d47a1;\n  --emr-catalog-text: #212121;\n  --emr-catalog-muted: #616161;\n  --emr-catalog-border: #e0e0e0;\n  --emr-catalog-surface: #ffffff;\n  max-width: none;\n  margin: 0;\n  min-width: 0;\n  width: 100%;\n  box-sizing: border-box;\n  color: var(--emr-catalog-text);\n  overflow-x: hidden;\n}\n\n.emr-catalog__pagehead {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 12px;\n  margin-bottom: 8px;\n  min-width: 0;\n}\n\n.emr-mz-dashboard .emr-catalog__title,\n.emr-catalog__title {\n  margin: 0;\n  font-size: var(--emr-type-page-title) !important;\n  font-weight: 600;\n  line-height: 1.25;\n  color: var(--emr-catalog-text);\n}\n\n.emr-catalog__workspace {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr);\n  gap: 8px;\n  align-items: start;\n  min-width: 0;\n}\n\n.emr-catalog__side {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr);\n  gap: 8px;\n  align-content: start;\n  min-width: 0;\n}\n\n.emr-catalog__catalog {\n  min-width: 0;\n}\n\n.emr-catalog .card.emr-catalog__section,\n.emr-catalog__section {\n  margin: 0;\n  width: 100%;\n  max-width: 100%;\n  min-width: 0;\n  overflow: hidden;\n  background: var(--emr-catalog-surface);\n  border: 1px solid var(--emr-catalog-border);\n  border-right: 3px solid var(--emr-catalog-primary);\n  box-shadow: none;\n  padding: 8px 12px 10px;\n  box-sizing: border-box;\n}\n\n.emr-catalog__section-title {\n  margin: 0 0 6px;\n  font-size: var(--emr-type-metadata) !important;\n  font-weight: 600;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: var(--emr-catalog-muted);\n}\n\n.emr-catalog__copy {\n  margin: 0;\n  font-size: var(--emr-type-body);\n  font-weight: 400;\n  line-height: 1.4;\n  color: var(--emr-catalog-text);\n}\n\n.emr-catalog__section--notice {\n  background: #fff8e1;\n  border-color: #ffe082;\n  border-right-width: 3px;\n  border-right-color: var(--emr-catalog-primary);\n}\n\n.emr-catalog__section--notice .emr-catalog__section-title {\n  color: #f57f17;\n}\n\n.emr-catalog__section--notice .emr-catalog__copy {\n  color: #5d4037;\n}\n\n.emr-catalog__status-msg,\n.emr-catalog__empty {\n  padding: 28px 16px;\n  text-align: center;\n  font-size: var(--emr-type-body);\n  color: var(--emr-catalog-muted);\n}\n\n.emr-catalog__empty {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 8px;\n}\n\n.emr-catalog__empty-icon {\n  width: 32px;\n  height: 32px;\n  color: #bdbdbd;\n}\n\n.emr-catalog__error {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 8px;\n  padding: 28px 16px;\n  text-align: center;\n}\n\n.emr-catalog__error-icon {\n  width: 32px;\n  height: 32px;\n  color: #ef9a9a;\n}\n\n.emr-catalog__error-copy {\n  margin: 0;\n  max-width: 28rem;\n  font-size: var(--emr-type-body);\n  color: var(--emr-catalog-muted);\n}\n\n.emr-mz-dashboard .btn.emr-catalog__retry,\n.emr-catalog__retry {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  height: 36px;\n  padding: 0 14px;\n  margin: 0;\n  background: #fff !important;\n  color: var(--emr-catalog-primary) !important;\n  border: 1px solid var(--emr-catalog-primary);\n  box-shadow: none;\n}\n\n.emr-mz-dashboard .btn.emr-catalog__retry:hover,\n.emr-catalog__retry:hover {\n  background: #e3f2fd !important;\n}\n\n.emr-catalog__table-wrap {\n  display: block;\n  width: 100%;\n  max-width: 100%;\n  min-width: 0;\n  overflow-x: auto;\n  overflow-y: hidden;\n  -webkit-overflow-scrolling: touch;\n}\n\n/* (0,2,1) so the 16px band beats Materialize's\n   `.emr-mz-dashboard table { font-size: var(--emr-type-table) }` (0,1,1). */\n.emr-mz-dashboard table.emr-catalog__table,\n.emr-catalog__table {\n  display: table;\n  width: 100%;\n  min-width: 720px;\n  border-collapse: collapse;\n  position: static;\n  font-family: var(--emr-font-sans);\n  font-size: 16px;\n}\n\n.emr-mz-dashboard table.emr-catalog__table thead {\n  display: table-header-group;\n  position: static;\n  float: none;\n  overflow: visible;\n  width: auto;\n}\n\n.emr-mz-dashboard table.emr-catalog__table tbody {\n  display: table-row-group;\n}\n\n.emr-mz-dashboard table.emr-catalog__table tr {\n  display: table-row;\n}\n\n/* Row geometry lives here on purpose. This selector is (0,2,2) and therefore\n * outranks the `.emr-mz-dashboard .emr-catalog__table td` rule below at (0,2,1),\n * so vertical padding and line-height set further down would lose. It also\n * clears Materialize's `.emr-mz-dashboard td, th { padding: 15px 5px }` (0,1,1)\n * without !important.\n *\n * Same accepted clinical density as the patient-chart and worklist tables:\n * Arial, 16px text on a 16px line, 20px data rows, 2px vertical cell padding.\n * The 12px horizontal gutter is kept from the existing design — these tables\n * declare a min-width and scroll inside .emr-catalog__table-wrap, so narrowing\n * the gutter would only crowd the columns.\n *\n * font-family stops at the cell: `.emr-mz-dashboard.emr-mz-dashboard .font-fhir`\n * is (0,3,0) and still wins, so code columns (ICD-10-CM, CPT, Px Master local\n * codes, NPIs) stay monospace at the 16px standard.\n */\n.emr-mz-dashboard table.emr-catalog__table th,\n.emr-mz-dashboard table.emr-catalog__table td {\n  display: table-cell;\n  box-sizing: border-box;\n  height: 20px;\n  max-height: 20px;\n  padding-top: 2px;\n  padding-bottom: 2px;\n  font-family: var(--emr-font-sans);\n  font-size: 16px;\n  line-height: 16px;\n  vertical-align: middle;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  /* On a single line the long free-text columns (CPT and ICD-10-CM official\n     descriptions, placeholder meanings and sources, provider organizations) no\n     longer wrap, so `table-layout: auto` would size them to their full string\n     and push later columns out of the scroll viewport. Capping the column is\n     what makes the ellipsis above reachable. */\n  max-width: 360px;\n}\n\n.emr-mz-dashboard .emr-catalog__table th {\n  font-size: 16px;\n  font-weight: 600;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: var(--emr-catalog-muted);\n  padding: 2px 12px;\n  line-height: 16px;\n  border-bottom: 1px solid var(--emr-catalog-border);\n  background: #fafbfc;\n  white-space: nowrap;\n}\n\n.emr-mz-dashboard .emr-catalog__table td {\n  font-size: 16px;\n  font-weight: 400;\n  padding: 2px 12px;\n  line-height: 16px;\n  color: var(--emr-catalog-text);\n  border-bottom: 1px solid #f0f0f0;\n  vertical-align: middle;\n}\n\n.emr-catalog__name {\n  font-weight: 600;\n  color: var(--emr-catalog-primary-dark);\n}\n\n.emr-catalog__muted {\n  font-size: var(--emr-type-helper);\n  color: var(--emr-catalog-muted);\n}\n\n/* A 20px row leaves a 16px content box once 2px + 2px cell padding is taken,\n   so every in-row chip, token and action button is sized to exactly 16px. */\n.emr-catalog__status {\n  display: inline-flex;\n  align-items: center;\n  height: 16px;\n  padding: 0 8px;\n  font-size: 16px;\n  line-height: 16px;\n  font-weight: 600;\n  letter-spacing: 0.02em;\n  white-space: nowrap;\n}\n\n.emr-catalog__status--active {\n  background: #e3f2fd;\n  color: #1565c0;\n}\n\n.emr-catalog__status--transform {\n  background: #fff8e1;\n  color: #f57f17;\n}\n\n.emr-catalog__status--inactive {\n  background: #eceff1;\n  color: #546e7a;\n}\n\n.emr-catalog__token--placeholder {\n  font-family: var(--emr-font-mono);\n  letter-spacing: 0;\n  font-weight: 600;\n}\n\n/* Placeholder Vocabulary renders its token as <code>, where Materialize's\n   `.emr-mz-dashboard code { font-size: 1em }` (0,1,1) outranks this rule and the\n   token inherits the cell instead. Both paths now land on 16px. */\n.emr-catalog__token {\n  display: inline-flex;\n  align-items: center;\n  height: 16px;\n  padding: 0 7px;\n  background: #eceff1;\n  color: #37474f;\n  font-size: 16px;\n  line-height: 16px;\n  font-weight: 600;\n  letter-spacing: 0.02em;\n  white-space: nowrap;\n}\n\n/* Referring Providers is the one column that used to wrap an address over\n   several lines. On a 20px row it becomes a single truncated line, the same\n   treatment the accepted Appointments notes column already uses; the full\n   address stays available in the provider detail. Qualified to (0,3,2) so this\n   column keeps its own tighter bound instead of the table-wide 360px cap. */\n.emr-mz-dashboard table.emr-catalog__table td.emr-catalog__address,\n.emr-catalog__address {\n  max-width: 260px;\n}\n\n.emr-mz-dashboard table.emr-catalog__table--wide,\n.emr-catalog__table--wide {\n  min-width: 1080px;\n}\n\n@media only screen and (min-width: 1024px) {\n  .emr-catalog__side {\n    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);\n  }\n}\n\n@media only screen and (min-width: 1440px) {\n  .emr-catalog__workspace {\n    grid-template-columns: minmax(280px, 340px) minmax(0, 1fr);\n  }\n\n  .emr-catalog__side {\n    grid-template-columns: minmax(0, 1fr);\n  }\n\n  .emr-catalog--full-table .emr-catalog__workspace {\n    grid-template-columns: minmax(0, 1fr);\n  }\n\n  .emr-catalog--full-table .emr-catalog__side {\n    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);\n  }\n}\n\n@media only screen and (max-width: 600px) {\n  .emr-mz-dashboard .emr-catalog__title,\n  .emr-catalog__title {\n    font-size: var(--emr-type-page-title-compact) !important;\n  }\n\n  .emr-mz-dashboard .emr-catalog__table th,\n  .emr-mz-dashboard .emr-catalog__table td {\n    padding: 2px 10px;\n  }\n\n  .emr-mz-dashboard table.emr-catalog__table,\n  .emr-catalog__table {\n    min-width: 560px;\n  }\n\n  .emr-mz-dashboard table.emr-catalog__table--wide,\n  .emr-catalog__table--wide {\n    min-width: 960px;\n  }\n\n  .emr-catalog__pagehead {\n    flex-direction: column;\n    align-items: stretch;\n    gap: 8px;\n  }\n\n  .emr-mz-dashboard .btn.emr-catalog__btn,\n  .emr-catalog__btn {\n    width: 100%;\n    justify-content: center;\n  }\n\n  .emr-catalog__filters {\n    grid-template-columns: minmax(0, 1fr);\n  }\n}\n\n.emr-catalog__subtitle {\n  margin: 2px 0 0;\n  font-size: var(--emr-type-helper);\n  font-weight: 400;\n  color: var(--emr-catalog-muted);\n}\n\n.emr-mz-dashboard .btn.emr-catalog__btn,\n.emr-catalog__btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  height: 36px;\n  padding: 0 14px;\n  margin: 0;\n  flex-shrink: 0;\n  background: var(--emr-catalog-primary) !important;\n  color: #fff !important;\n  border: 0;\n  box-shadow: none;\n  text-transform: none;\n  font-size: var(--emr-type-button);\n  font-weight: 600;\n  line-height: 36px;\n}\n\n.emr-mz-dashboard .btn.emr-catalog__btn:hover,\n.emr-catalog__btn:hover {\n  background: var(--emr-catalog-primary-dark) !important;\n}\n\n.emr-catalog__btn-icon {\n  width: 16px;\n  height: 16px;\n}\n\n.emr-mz-dashboard .btn.emr-catalog__btn--ghost,\n.emr-catalog__btn--ghost {\n  background: #fff !important;\n  color: var(--emr-catalog-primary) !important;\n  border: 1px solid var(--emr-catalog-primary);\n}\n\n.emr-mz-dashboard .btn.emr-catalog__btn--ghost:hover,\n.emr-catalog__btn--ghost:hover {\n  background: #e3f2fd !important;\n}\n\n.emr-mz-dashboard .btn.emr-catalog__btn--danger,\n.emr-catalog__btn--danger {\n  background: #d32f2f !important;\n}\n\n.emr-catalog__filters {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr);\n  gap: 8px;\n  align-items: end;\n  min-width: 0;\n}\n\n.emr-catalog__search {\n  position: relative;\n  min-width: 0;\n  width: 100%;\n}\n\n.emr-catalog__search-icon {\n  position: absolute;\n  left: 10px;\n  top: 50%;\n  width: 16px;\n  height: 16px;\n  margin-top: -8px;\n  color: #9e9e9e;\n  pointer-events: none;\n}\n\n.emr-mz-dashboard .emr-catalog__input,\n.emr-catalog__input,\n.emr-mz-dashboard .emr-catalog__select,\n.emr-catalog__select,\n.emr-mz-dashboard .emr-catalog__filter-trigger,\n.emr-catalog__filter-trigger {\n  height: 36px !important;\n  min-height: 36px !important;\n  width: 100% !important;\n  max-width: 100%;\n  min-width: 0;\n  box-sizing: border-box !important;\n  margin: 0;\n  border: 1px solid var(--emr-catalog-border) !important;\n  background: var(--emr-catalog-surface) !important;\n  box-shadow: none !important;\n  font-size: var(--emr-type-body) !important;\n  font-weight: 400 !important;\n  color: var(--emr-catalog-text) !important;\n}\n\n.emr-mz-dashboard .emr-catalog__input,\n.emr-catalog__input {\n  padding: 0 10px 0 32px !important;\n}\n\n.emr-mz-dashboard .emr-catalog__select,\n.emr-catalog__select {\n  padding: 0 8px !important;\n  display: block;\n}\n\n.emr-catalog-select {\n  border-radius: 0 !important;\n  border: 1px solid var(--emr-catalog-border) !important;\n  background: #fff !important;\n  box-shadow: none !important;\n}\n\n.emr-catalog__field {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  min-width: 0;\n}\n\n.emr-catalog__field > span,\n.emr-catalog__field-label {\n  font-size: var(--emr-type-label);\n  font-weight: 600;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  color: var(--emr-catalog-muted);\n}\n\n.emr-catalog__switch {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  height: 36px;\n  padding: 0 10px;\n  border: 1px solid var(--emr-catalog-border);\n  background: var(--emr-catalog-surface);\n  font-size: var(--emr-type-body);\n  color: var(--emr-catalog-text);\n}\n\n/* The DEMO flag keeps --emr-type-micro: emr-typography.css reserves sub-12px\n   for exactly this kind of incidental chrome (\"rulers, demo-data flags\"). Only\n   its box shrinks, so it fits the 16px content box.\n   It sits beside the name text, and a 16px box aligned `middle` in a 16px line\n   box overhangs it by 0.77px, which grew the whole row. `top` fills the line box\n   exactly, so the chip still reads centred and the row stays at 20px. */\n.emr-catalog__demo {\n  display: inline-flex;\n  align-items: center;\n  height: 16px;\n  margin-left: 8px;\n  padding: 0 6px;\n  background: #fff8e1;\n  color: #f9a825;\n  font-size: var(--emr-type-micro);\n  font-weight: 700;\n  letter-spacing: 0.06em;\n  vertical-align: top;\n}\n\n.emr-catalog__status--suspended {\n  background: #fff8e1;\n  color: #f9a825;\n}\n\n.emr-catalog__actions-col {\n  text-align: right;\n  white-space: nowrap;\n}\n\n.emr-catalog__row-actions {\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  gap: 2px;\n  height: 16px;\n}\n\n/* Role tokens on Users used to wrap onto a second line. They now stay on one\n   line inside the row and the cell truncates, matching every other column. */\n.emr-catalog__chips {\n  display: flex;\n  flex-wrap: nowrap;\n  justify-content: flex-start;\n  align-items: center;\n  gap: 4px;\n  height: 16px;\n  overflow: hidden;\n}\n\n.emr-mz-dashboard .emr-catalog-icon-btn {\n  width: 16px !important;\n  height: 16px !important;\n  min-width: 16px !important;\n  min-height: 16px !important;\n  padding: 0 !important;\n  line-height: 1 !important;\n  color: var(--emr-catalog-primary);\n}\n\n.emr-mz-dashboard .emr-catalog-icon-btn--danger {\n  color: #d32f2f;\n}\n\n.emr-mz-dashboard a.emr-catalog__link,\n.emr-catalog__link {\n  color: var(--emr-catalog-primary-dark);\n  font-weight: 600;\n  text-decoration: none;\n}\n\n.emr-mz-dashboard a.emr-catalog__link:hover,\n.emr-catalog__link:hover {\n  text-decoration: underline;\n}\n\n.emr-catalog__pager {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  margin-top: 8px;\n  padding-top: 8px;\n  border-top: 1px solid var(--emr-catalog-border);\n  font-size: var(--emr-type-label);\n  color: var(--emr-catalog-muted);\n}\n\n.emr-catalog__cap {\n  margin: 8px 0 0;\n  padding: 6px 8px;\n  background: #fff8e1;\n  color: #5d4037;\n  font-size: var(--emr-type-helper);\n  text-align: center;\n}\n\n.emr-catalog__meta {\n  margin: 6px 0 0;\n  font-size: var(--emr-type-helper);\n  color: var(--emr-catalog-muted);\n}\n\n/* Prefixed and element-qualified so the 16px line beats Materialize's\n   `.emr-mz-dashboard button { line-height: 1.15 }` (0,1,1) without !important. */\n.emr-mz-dashboard button.emr-catalog__text-btn,\n.emr-catalog__text-btn {\n  display: inline-flex;\n  align-items: center;\n  height: 16px;\n  padding: 0 6px;\n  border: 0;\n  background: transparent;\n  color: var(--emr-catalog-primary);\n  font-size: 16px;\n  line-height: 16px;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.emr-catalog__text-btn:hover {\n  text-decoration: underline;\n}\n\n@media only screen and (min-width: 720px) {\n  .emr-catalog__filters {\n    grid-template-columns: minmax(0, 1.4fr) repeat(auto-fit, minmax(140px, 180px));\n  }\n\n  .emr-catalog__filters--search-only {\n    grid-template-columns: minmax(0, 1fr);\n    max-width: 420px;\n  }\n\n  .emr-catalog__filters--search-row {\n    grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));\n  }\n\n  .emr-catalog__filters--search-row .emr-catalog__search {\n    grid-column: 1 / -1;\n    min-width: 0;\n  }\n\n  .emr-catalog__filters--vocab {\n    grid-template-columns: minmax(22rem, max-content) max-content;\n  }\n\n  .emr-catalog__select--wide {\n    width: auto !important;\n    min-width: 22rem !important;\n    max-width: 32rem;\n  }\n}\n\n.emr-catalog--access {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr);\n  gap: 8px;\n}\n\n.emr-catalog--access .emr-catalog__pagehead {\n  margin-bottom: 0;\n}\n\n.emr-catalog--access .emr-catalog__workspace {\n  gap: 8px;\n}\n\n.emr-catalog--access .ac-tabs {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 8px;\n  margin: 0;\n}\n\n.emr-catalog--access .ac-tab {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  min-width: 0;\n  border: 1px solid var(--emr-catalog-border);\n  background: #fff;\n  padding: 8px 10px;\n  text-align: left;\n  color: var(--emr-catalog-text);\n}\n\n.emr-catalog--access .ac-tab.is-active {\n  border-color: var(--emr-catalog-primary);\n  box-shadow: inset 0 -3px 0 var(--emr-catalog-primary);\n  color: var(--emr-catalog-primary-dark);\n}\n\n.emr-catalog--access .ac-tab.is-disabled {\n  opacity: 0.55;\n  cursor: not-allowed;\n}\n\n.emr-catalog--access .ac-tab-label {\n  display: block;\n  font-size: var(--emr-type-body);\n  font-weight: 600;\n}\n\n.emr-catalog--access .ac-tab-sub {\n  display: block;\n  font-size: var(--emr-type-metadata);\n  color: var(--emr-catalog-muted);\n}\n\n.emr-catalog--access .ac-toolbar,\n.emr-catalog--access .ac-toolbar--user {\n  display: grid;\n  grid-template-columns: minmax(160px, 240px) minmax(0, 1fr);\n  gap: 8px;\n  margin: 0;\n  align-items: start;\n}\n\n.emr-catalog--access .ac-field {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  font-size: var(--emr-type-label);\n  font-weight: 600;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  color: var(--emr-catalog-muted);\n}\n\n.emr-mz-dashboard .emr-catalog--access .ac-field select,\n.emr-catalog--access .ac-field select {\n  display: block !important;\n  visibility: visible !important;\n  opacity: 1 !important;\n  width: 100%;\n  max-width: 100%;\n  height: 36px !important;\n  min-height: 36px !important;\n  margin: 0;\n  border: 1px solid var(--emr-catalog-border);\n  background: #fff;\n  padding: 0 8px;\n  font-size: var(--emr-type-body);\n  font-weight: 400;\n  text-transform: none;\n  letter-spacing: 0;\n  color: var(--emr-catalog-text);\n  appearance: auto;\n  -webkit-appearance: menulist;\n}\n\n.emr-catalog--access .ac-info {\n  display: flex;\n  gap: 8px;\n  align-items: flex-start;\n  margin: 0;\n  background: #e3f2fd;\n  border: 1px solid #bbdefb;\n  color: var(--emr-catalog-primary-dark);\n  padding: 8px 10px;\n  font-size: var(--emr-type-body);\n}\n\n.emr-catalog--access .ac-employee {\n  display: grid;\n  grid-template-columns: repeat(5, minmax(0, 1fr));\n  gap: 8px;\n  margin: 0;\n  border: 0;\n  padding: 0;\n  background: transparent;\n}\n\n.emr-catalog--access .ac-employee span {\n  display: block;\n  font-size: var(--emr-type-metadata);\n  text-transform: uppercase;\n  letter-spacing: 0.06em;\n  color: var(--emr-catalog-muted);\n  font-weight: 600;\n}\n\n.emr-catalog--access .ac-employee strong {\n  display: block;\n  margin-top: 2px;\n  font-size: var(--emr-type-body);\n  color: var(--emr-catalog-text);\n  font-weight: 600;\n}\n\n.emr-catalog--access .ac-matrix,\n.emr-catalog--access .ac-hierarchy {\n  border-radius: 0 !important;\n  overflow-x: auto;\n  max-width: 100%;\n}\n\n.emr-catalog--access .ac-matrix-table th,\n.emr-catalog--access .ac-matrix-table td {\n  padding: 6px 8px;\n}\n\n.emr-catalog--access .ac-footer,\n.emr-catalog--access .ac-footer--user {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  margin: 0;\n}\n\n.emr-catalog--access .ac-save--default,\n.emr-catalog--access .ac-save--user {\n  background: var(--emr-catalog-primary) !important;\n  color: #fff !important;\n}\n\n.emr-catalog--access .ac-save--default:hover,\n.emr-catalog--access .ac-save--user:hover {\n  background: var(--emr-catalog-primary-dark) !important;\n}\n\n.emr-catalog--access .ac-loading,\n.emr-catalog--access .ac-footnote {\n  margin: 0;\n  font-size: var(--emr-type-helper);\n  color: var(--emr-catalog-muted);\n}\n\n@media only screen and (max-width: 900px) {\n  .emr-catalog--access .ac-tabs,\n  .emr-catalog--access .ac-toolbar,\n  .emr-catalog--access .ac-toolbar--user,\n  .emr-catalog--access .ac-employee,\n  .emr-catalog--access .ac-footer,\n  .emr-catalog--access .ac-footer--user {\n    grid-template-columns: minmax(0, 1fr);\n    display: flex;\n    flex-direction: column;\n  }\n}\n\n.emr-catalog--access .ac-workspace-tabs {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 8px;\n  margin: 0;\n}\n\n.emr-catalog--access .ac-workspace-tab {\n  display: flex;\n  align-items: flex-start;\n  gap: 10px;\n  min-width: 0;\n  border: 1px solid var(--emr-catalog-border);\n  background: #fff;\n  padding: 10px 12px;\n  text-align: left;\n  color: var(--emr-catalog-text);\n}\n\n.emr-catalog--access .ac-workspace-tab.is-active {\n  border-color: var(--emr-catalog-primary);\n  background: #e3f2fd;\n  box-shadow: inset 0 -3px 0 var(--emr-catalog-primary);\n  color: var(--emr-catalog-primary-dark);\n}\n\n.emr-catalog--access .ac-role-help {\n  flex-shrink: 0;\n}\n\n.emr-catalog--access .ac-perm {\n  display: grid;\n  gap: 8px;\n  min-width: 0;\n}\n\n.emr-catalog--access .ac-perm-title {\n  margin: 0;\n  font-size: var(--emr-type-section-title) !important;\n  font-weight: 600;\n  color: var(--emr-catalog-text);\n  text-transform: none;\n  letter-spacing: 0;\n}\n\n.emr-catalog--access .ac-perm-subtitle,\n.emr-catalog--access .ac-perm-preferred-note {\n  margin: 2px 0 0;\n  font-size: var(--emr-type-helper);\n  color: var(--emr-catalog-muted);\n  font-weight: 400;\n  text-transform: none;\n  letter-spacing: 0;\n}\n\n.emr-catalog--access .ac-perm-toolbar {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  margin-top: 8px;\n  flex-wrap: wrap;\n}\n\n.emr-catalog--access .ac-perm-preferred {\n  height: 32px;\n  padding: 0 10px;\n}\n\n.emr-catalog--access .ac-perm-guide {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  font-size: var(--emr-type-body);\n  font-weight: 600;\n  color: var(--emr-catalog-primary-dark);\n  text-decoration: underline;\n  text-underline-offset: 2px;\n}\n\n.emr-catalog--access .ac-perm-guide svg {\n  width: 14px;\n  height: 14px;\n}\n\n.emr-catalog--access .ac-perm-group-title {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin: 0 0 6px;\n  font-size: var(--emr-type-card-title) !important;\n  font-weight: var(--emr-weight-title);\n  letter-spacing: 0.02em;\n  text-transform: none;\n  color: var(--emr-catalog-text);\n}\n\n.emr-catalog--access .ac-perm-num {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 18px;\n  height: 18px;\n  padding: 0 5px;\n  background: #e3f2fd;\n  color: var(--emr-catalog-primary-dark);\n  font-size: var(--emr-type-micro);\n  font-weight: 700;\n}\n\n.emr-catalog--access .ac-perm-table-wrap {\n  overflow-x: auto;\n  max-width: 100%;\n}\n\n.emr-catalog--access .ac-perm-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: var(--emr-type-table-dense);\n}\n\n.emr-catalog--access .ac-perm-table th,\n.emr-catalog--access .ac-perm-table td {\n  border-bottom: 1px solid var(--emr-catalog-border);\n  padding: 4px 8px;\n  text-align: left;\n  vertical-align: middle;\n}\n\n.emr-catalog--access .ac-perm-table thead th {\n  font-size: var(--emr-type-table-head);\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  color: var(--emr-catalog-muted);\n  background: #fafafa;\n  white-space: nowrap;\n}\n\n.emr-catalog--access .ac-perm-table thead th:not(:first-child),\n.emr-catalog--access .ac-perm-table td {\n  text-align: center;\n  width: 110px;\n}\n\n.emr-catalog--access .ac-perm-label {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  font-weight: 500;\n  color: var(--emr-catalog-text);\n}\n\n.emr-catalog--access .ac-perm-info {\n  position: relative;\n  display: inline-flex;\n}\n\n.emr-catalog--access .ac-perm-info-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 18px;\n  height: 18px;\n  padding: 0;\n  border: 0;\n  background: transparent;\n  color: var(--emr-catalog-muted);\n  cursor: pointer;\n}\n\n.emr-catalog--access .ac-perm-info-btn svg {\n  width: 13px;\n  height: 13px;\n}\n\n.emr-catalog--access .ac-perm-tip {\n  display: none;\n  position: absolute;\n  left: 0;\n  top: 20px;\n  z-index: 8;\n  min-width: 180px;\n  max-width: 260px;\n  padding: 6px 8px;\n  background: #0d47a1;\n  color: #fff;\n  font-size: var(--emr-type-helper);\n  font-weight: 400;\n  line-height: 1.35;\n  box-shadow: 0 2px 8px rgba(13, 71, 161, 0.25);\n}\n\n.emr-catalog--access .ac-perm-info:hover .ac-perm-tip,\n.emr-catalog--access .ac-perm-info:focus-within .ac-perm-tip,\n.emr-catalog--access .ac-perm-info.is-open .ac-perm-tip {\n  display: block;\n}\n\n.emr-catalog--access .ac-perm-check-wrap {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  margin: 0;\n}\n\n.emr-mz-dashboard .emr-catalog--access input.ac-perm-check[type=\"checkbox\"],\n.emr-catalog--access input.ac-perm-check[type=\"checkbox\"] {\n  position: static !important;\n  left: auto !important;\n  opacity: 1 !important;\n  pointer-events: auto !important;\n  visibility: visible !important;\n  appearance: auto !important;\n  -webkit-appearance: checkbox !important;\n  width: 16px !important;\n  height: 16px !important;\n  margin: 0 !important;\n  z-index: auto !important;\n  accent-color: #1976d2;\n}\n\n.emr-catalog--access .ac-perm-footer {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  flex-wrap: wrap;\n  margin-top: 0;\n}\n\n.emr-catalog--access .ac-perm-actions {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.emr-catalog--access .ac-role-copy {\n  display: grid;\n  gap: 8px;\n  text-align: left;\n  color: var(--emr-catalog-text);\n}\n\n.emr-catalog--access .ac-role-copy p {\n  margin: 0;\n  font-size: var(--emr-type-body);\n  line-height: 1.45;\n}\n\n@media only screen and (max-width: 1100px) {\n  .emr-catalog--access .ac-workspace-tabs {\n    grid-template-columns: minmax(0, 1fr);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
